import React from 'react';

const StarIcon = ({ fillColor, ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none" {...rest}>
      <path
        d="M5 0L6.46946 2.97746L9.75528 3.45492L7.37764 5.77254L7.93893 9.04508L5 7.5L2.06107 9.04508L2.62236 5.77254L0.244718 3.45492L3.53054 2.97746L5 0Z"
        fill={fillColor}
      />
    </svg>
  );
};

export default StarIcon;
